import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const blockProps = useBlockProps.save({
		className: 'c4l-quote',
	});

	const { attributes } = props;
	const { text, caption } = attributes;

	return (
		<div {...blockProps}>
			<div className='c4l-quote-content'>
				<RichText.Content
					tagName='div'
					className='c4l-quote-text'
					value={text}
				/>
				<RichText.Content
					tagName='div'
					className='c4l-quote-caption'
					value={caption}
				/>
			</div>
		</div>
	);
}
